import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { node, object } from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

import classes from './LoadingIndicator.module.css';

const LoadingIndicator = forwardRef(({
    children,
    className,
    progressProps
}, ref) => (
    <div className={clsx(classes.root, className)} ref={ref}>
        <div className={classes.container}>
            <CircularProgress {...progressProps} />
            <div className={classes.label}>{children}</div>
        </div>
    </div>
));


LoadingIndicator.propTypes = {
    children:      node,
    progressProps: object
};

export default LoadingIndicator;
